<template>
    <div class="flex_1 margin_horizontal payments_page">
		<AccessRestrictedButtonGroup v-show="false"
									 class="flex flex_center table_button_group"
									 v-model="activeButton"
									 :elements="buttonGroupTypes"
									 :session-key="$route.path"
		/>
        <el-tabs class="table_tabs margin_top" v-model="activeAccountTab">
            <el-tab-pane v-for="account in accountList"
                         :name="String(account.id)"
                         :key="account.id"
            >
                    <el-tooltip slot="label" popper-class="tooltip-md" placement="bottom"
                                :content="$t('common.account.deactivated')"
                                :disabled="account.enabled"
                                :open-delay="750"
                    >
                        <span>
                            <i v-if="!account.enabled" class="fa fa-ban"></i>
                            {{formatAccountDisplay(account)}}
                        </span>
                    </el-tooltip>
            </el-tab-pane>
        </el-tabs>
        <InvestorReceivablePaymentsTable
			v-if="activeButton && activeButton.name === buttonGroupTypes.receivablePayments.name"
			:accountId="activeAccountId"
			:accounts-assigned="accountsAssigned"
        />
<!--		https://walbing-jira.atlassian.net/browse/DEV-5659-->
<!--		<InvestorPaymentsRevolvingPutOptionsTable-->
<!--			v-if="activeButton && activeButton.name === buttonGroupTypes.revolvingPayments.name"-->
<!--			:accountId="activeAccountId"-->
<!--			:accounts-assigned="accountsAssigned"-->
<!--		/>-->
    </div>
</template>

<script>
import InvestorReceivablePaymentsTable
	from "@/components/templates/investor/payments/receivables/InvestorReceivablePaymentsTable.vue";
import {investorPaymentsReceivablesApi} from "@/common/api/investorPaymentsReceivablesApi";
import {enumDef} from "@/common/enumDefs";
import AccessRestrictedButtonGroup from "@/components/templates/common/permissions/AccessRestrictedButtonGroup";
import InvestorPaymentsRevolvingPutOptionsTable
	from "@/components/templates/investor/payments/revolving/InvestorPaymentsRevolvingPutOptionsTable";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
    components: {
		InvestorPaymentsRevolvingPutOptionsTable,
		InvestorReceivablePaymentsTable,
		AccessRestrictedButtonGroup
	},
    data() {
		let buttonGroupTypes = {
			receivablePayments: {
				name: navigationTabs.investor.payments.receivables,
				translationKey: "payments.tradeReceivables",
				api: investorPaymentsReceivablesApi,
				permission: enumDef.permissions.InvestorExchangeReceivables
			},
			// https://walbing-jira.atlassian.net/browse/DEV-5659
			// revolvingPayments: {
			// 	name: navigationTabs.investor.payments.putOptions,
			// 	translationKey: "payments.revolvingPutOptions",
			// 	api: investorPaymentsReceivablesApi,
			// 	permission: enumDef.permissions.InvestorExchangeRevolvingPutOptions
			// }
		};

        return {
			activeButton: null,
			buttonGroupTypes: buttonGroupTypes,
            accountList: null,
            activeAccountTab: "-1",
        };
    },
    computed: {
        activeAccountId() {
            return Number(this.activeAccountTab);
        },
        accountsAssigned() {
          return this.accountList === null || this.accountList.length > 0;
        },
    },
    methods: {
        getAccounts() {
			this.activeButton.api.inspection.getAccounts()
                .then(res => {
                    this.accountList = res;

                    if (this.accountList.length > 0) {
						this.activeAccountTab = this.$store.getters["session/activeTabs"][this.$route.path.concat("&account")] || String(res[0].id);
                    }
                })
                .catch(e => {
                    this.toast(e);
                });
        },
        formatAccountDisplay(account) {
            return (account.tag || account.tbIban) + " (" + account.tbCurrType + ")";
        }
    },
	watch: {
		activeButton() {
			this.getAccounts();
		},
		activeAccountTab() {
			this.$store.dispatch("session/setActiveTab", { tabGroup: this.$route.path.concat("&account"), activeTab: this.activeAccountTab });
		}
	}
};
</script>
